module.exports = __webpack_public_path__ + "static/media/video.f9ce3603.mp4";